import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { triggerFocus } from 'antd/lib/input/Input';

export const initialState: any = {
  loading: false,
  territoryCodeMapperList: [],
  countryCode:"us",
  reset: false,
  filter:null
};

const slice = createSlice({
  name: 'Plant Mappers',
  initialState,
  reducers: {
    setTerritoryCodeMapperList: (state, { payload }: PayloadAction<any>) => {
      state.loading = false;
      state.territoryCodeMapperList = payload || [];
      state.reset = false;
    },
    reset: (state) => {
      state.reset = true;
    },
    setCountry: (state, { payload }: PayloadAction<any>) => {
      state.countryCode = payload;
    },
    setFilter: (state, { payload }: PayloadAction<any>) => {
      state.filter = payload;
    },
  }
});

export const { setTerritoryCodeMapperList, setCountry,setFilter,reset } = slice.actions;

export default slice.reducer;
